<template>
    <form v-if="sequence" v-on:submit.prevent="save">

        <div class="row">
            <div class="col-md-12">
                <!-- Custom Tabs -->
                <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                        <li :class="tab1Class"><a href="#tab_1" data-toggle="tab">Generali</a></li>
                        <li><a href="#tab_2" data-toggle="tab">Descrizione</a></li>
                        <li :class="tab2Class"><a href="#tab_3" data-toggle="tab">Mappa</a></li>

                        <li class="pull-right">
                            <button class="btn btn-success btn-block" v-if="!disabled" v-on:click.prevent="save">
                                <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                                Salva
                            </button>

                            <button class="btn btn-warning btn-block" v-on:click.prevent="activateMod"
                                    v-if="disabled && $accessControl.isOperator($store.state.profile.profile)">
                                Attiva modifiche
                            </button>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div :class="['tab-pane',tab1Class]" id="tab_1">
                            <div class="row">
                                <div class="col-md-6">

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="titolo_">Titolo</label>
                                                <input type="text" class="form-control" id="titolo_"
                                                       name="titolo"
                                                       v-model="sequence.titolo" :disabled="true">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="abstract">Abstract</label>
                                                <textarea v-model="sequence.abstract" class="form-control"
                                                          id="abstract"
                                                          name="abstract"
                                                          :disabled="disabled"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="durata">Durata</label>
                                                <masked-input v-model="sequence.durata" mask="11:11:11"
                                                              placeholder="00:00:00" class="form-control" id="durata"
                                                              name="durata" :disabled="disabled"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="start">Inizio</label>
                                                <masked-input v-model="sequence.start" mask="11:11:11"
                                                              placeholder="00:00:00" class="form-control" id="start"
                                                              name="start" :disabled="disabled"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="end">Fine</label>
                                                <masked-input v-model="sequence.end" mask="11:11:11"
                                                              placeholder="00:00:00" class="form-control" id="end"
                                                              name="end" :disabled="disabled"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="titolo">Lunghezza</label>
                                                <input type="text" class="form-control" id="lunghezza"
                                                       name="lunghezza"
                                                       v-model="sequence.lunghezza" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="utilizzo">Utilizzo</label>
                                                <textarea v-model="sequence.utilizzo" class="form-control"
                                                          id="utilizzo"
                                                          name="utilizzo"
                                                          :disabled="disabled"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="note">Note</label>
                                                <textarea v-model="sequence.note" class="form-control"
                                                          id="note"
                                                          name="note"
                                                          :disabled="disabled"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="fuori_catalogo">Fuori catalogo</label>
                                                <select v-model="sequence.fuori_catalogo" class="form-control"
                                                        id="fuori_catalogo"
                                                        name="fuori_catalogo" :disabled="disabled">
                                                    <option></option>
                                                    <option v-for="(desc, id) in yn"
                                                            v-bind:value="id">
                                                        {{ desc }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!--image handle-->
                                <div class="col-md-6" v-if="showLabels">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ul id="gallery">
                                                <li v-for="image in sequence.sequenceimages.data">
                                                    <a :href="image.url" target="_blank">
                                                        <img :src="image.url"
                                                             class="img-responsive"/>
                                                    </a>

                                                    <button class="btn btn-xs btn-danger"
                                                            v-on:click.prevent="delImage(image.id)"
                                                            v-show="!disabled">
                                                        <i class="fa fa-remove"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <dropzone :style="{ border: '2px dashed', height: '200px', width: '100%' }"
                                                      :uploader="uploader" v-show="!disabled"/>
                                            <span class="text-bold"
                                                  v-show="!disabled">Trascina qui i file da caricare</span>
                                        </div>
                                    </div>
                                </div>
                                <!--/.image-handle-->
                            </div>
                        </div>
                        <!-- /.tab-pane -->

                        <div class="tab-pane" id="tab_2">
                            <div class="row">
                                <div class="col-md-6">
                                    <description :description="sequence.description.data" :persons="persons"
                                                 :disabled="disabled"></description>
                                </div>
                            </div>
                        </div>
                        <!-- /.tab-pane -->

                        <div :class="['tab-pane',tab2Class]" id="tab_3">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="titolo">Titolo</label>
                                                <input type="text" class="form-control" id="titolo"
                                                       name="titolo"
                                                       v-model="sequence.titolo" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="map_author">Autore - fondo</label>
                                                <input type="text" class="form-control" id="map_author"
                                                       name="map_author"
                                                       v-model="sequence.map_author" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="map_author">Anno</label>
                                                <input type="text" class="form-control" id="map_year"
                                                       name="map_year"
                                                       v-model="sequence.map_year" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="map_abstract">Abstract mappa</label>
                                                <textarea v-model="sequence.map_abstract" class="form-control"
                                                          id="map_abstract"
                                                          name="map_abstract"
                                                          :disabled="disabled"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <span class="text-bold">Localizzazione</span>
                                            <br/>
                                            <div class="form-group">
                                                <gmap-autocomplete
                                                        class="form-control"
                                                        placeholder="Cerca località"
                                                        @place_changed="setPlace"
                                                        v-on:keydown.enter.prevent=""
                                                        :disabled="disabled">
                                                </gmap-autocomplete>
                                            </div>
                                            <GmapMap
                                                    :center="marker.position"
                                                    :zoom="12"
                                                    ref="mapRef"
                                                    map-type-id="roadmap"
                                                    style="width: 500px; height: 300px"
                                                    :options="{
   zoomControl: true,
   mapTypeControl: false,
   scaleControl: false,
   streetViewControl: false,
   rotateControl: false,
   fullscreenControl: true,
   disableDefaultUi: false
 }">
                                                <GmapMarker
                                                        v-if="marker"
                                                        :position="marker.position"
                                                        :draggable="!disabled"
                                                        @dragend="markerDragEnd"
                                                />
                                            </GmapMap>
                                        </div>
                                    </div>
                                    <br/>

                                    <div class="row" v-if="showLabels">
                                        <div class="col-md-12">
                                            <span class="text-bold">Clip</span>
                                            <br/>
                                            <video ref="video" :src="sequence.video" controls
                                                   v-show="sequence.video && !uploading"></video>
                                        </div>
                                    </div>

                                    <div class="row" v-if="showLabels">
                                        <div class="col-md-12" v-show="!disabled">
                                            <span class="text-bold">Trascina qui la clip</span>
                                            <dropzone :style="{ border: '2px dashed', height: '200px', width: '100%' }"
                                                      :uploader="videoUploader" v-show="!disabled"/>
                                            <div class="box" v-show="uploading">
                                                <div class="overlay">
                                                    <i class="fa fa-refresh fa-spin"></i>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <br/>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="collections">Raccolte</label>
                                                <multiselect
                                                        v-model="sequence.collections.data"
                                                        :options="collections"
                                                        :multiple="true"
                                                        track-by="id"
                                                        label="title"
                                                        placeholder="seleziona"
                                                        SelectLabel="seleziona"
                                                        SelectedLabel="selezionato"
                                                        DeselectLabel="deseleziona"
                                                        id="collections"
                                                        name="collections"
                                                        :disabled="disabled"
                                                        :clear-on-select="false"
                                                        :searchable="true"
                                                        @search-change="collectionsFind">
                                                </multiselect>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Pubblicato</label>
                                                <div class="checkbox">
                                                    <label>
                                                        <input type="checkbox"
                                                               v-model="sequence.published"
                                                               :disabled="disabled">
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Vai alle raccolte</label>
                                                <br/>
                                                <router-link v-for="(collection) in sequence.collections.data" :to="{ name: 'collectionsShow', params: { id: collection.id }}" :key="collection.id">
                                                    <span class="label label-primary">
                                                        <strong>{{ collection.title }}</strong>
                                                    </span>
                                                    &nbsp;
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- /.tab-pane -->

                    </div>
                    <!-- /.tab-content -->

                    <div class="box-footer">
                        <div class="row">
                            <div class="col-md-2 col-md-offset-10">
                                <ul class="nav">
                                    <li class="pull-right">
                                        <button class="btn btn-success btn-block" v-if="!disabled"
                                                v-on:click.prevent="save">
                                            <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                                            Salva
                                        </button>

                                        <button class="btn btn-warning btn-block" v-on:click.prevent="activateMod"
                                                v-if="disabled && $accessControl.isOperator($store.state.profile.profile)">
                                            Attiva modifiche
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- nav-tabs-custom -->
            </div>
        </div>

    </form>
</template>

<script>
  import {clientDateFormat} from '../../filters'
  import personsApi from '../../api/persons'
  import sequencesApi from '../../api/sequences'
  import FineUploaderTraditional from 'fine-uploader-wrappers'
  import Dropzone from 'vue-fineuploader/dropzone'

  // Import this component
  import datePicker from 'vue-bootstrap-datetimepicker'
  // Import date picker css
  import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import Description from '../components/Description.vue'
  import MaskedInput from 'vue-masked-input'
  import collectionsApi from '@/api/collections'

  export default {
    props: ['disabled', 'sequence', 'loader', 'showLabels', 'reel', 'showMap'],
    methods: {
      save () {
        this.sequence.reel_id = this.reel.id
        this.$emit('click', this.sequence)
      },
      error (e) {
        console.log(e)
      },
      activateMod () {
        this.$emit('activate-mod', this.sequence)
      },
      delImage (id) {
        sequencesApi.deleteImage(this.sequence.id, id)
          .then((response) => {
            this.reel.sequenceimages = response.data.data.sequenceimages
            toastr.success('L\'immagine è stata rimossa correttamente')
          })
          .catch((response) => {
          })
      },
      setPlace (place) {
        this.place = place
        this.$refs.mapRef.$mapPromise.then((map) => {
          map.panTo({lat: this.place.geometry.location.lat(), lng: this.place.geometry.location.lng()})
          this.usePlace()
        })
      },
      usePlace () {
        if (this.place) {
          this.marker = {
            position: {
              lat: this.place.geometry.location.lat(),
              lng: this.place.geometry.location.lng()
            }
          }
          this.place = null
          this.sequence.lat = this.marker.position.lat
          this.sequence.lng = this.marker.position.lng
        }
      },
      markerDragEnd (marker) {
        this.sequence.lat = marker.latLng.lat()
        this.sequence.lng = marker.latLng.lng()
      },
      collectionsFind (query) {
        collectionsApi.select(query)
          .then((response) => {
            this.collections = response.data.data
          })
      }
    },

    data () {
      return {
        config: {
          format: clientDateFormat
        },
        persons: [],
        uploader: new FineUploaderTraditional({
          options: []
        }),
        videoUploader: new FineUploaderTraditional({
          options: []
        }),
        place: null,
        marker: {
          position: {
            lat: 45.69610605462603,
            lng: 9.673149926953101
          }
        },
        collections: [],
        uploading: false
      }
    },

    watch: {
      sequence: function (val) {
        if (this.showLabels && val.lat !== null && val.lng !== null) {
          this.marker = {
            position: {
              lat: val.lat,
              lng: val.lng
            }
          }
        }
        this.uploader = new FineUploaderTraditional({
          options: {
            request: {
              endpoint: process.env.BASE_URL + '/sequences/' + val.id + '/sequenceimage',
              customHeaders: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
              },
              inputName: 'image'
            },
            callbacks: {
              onComplete: (id, name, response) => {
                this.sequence.sequenceimages = response.data.sequenceimages
              }
            }
          }
        })
        this.videoUploader = new FineUploaderTraditional({
          options: {
            request: {
              endpoint: process.env.BASE_URL + '/sequences/' + val.id + '/video',
              customHeaders: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
              },
              inputName: 'video'
            },
            callbacks: {
              onProgress: () => {
                this.uploading = true
              },
              onComplete: (id, name, response) => {
                this.uploading = false
                this.sequence.video = response.data.video
                this.$emit('update-sequence-prop', this.sequence)
              }
            }
          }
        })
      }
    },

    computed: {
      yn () {
        return this.$store.state.decoder.decoders['_dYesNo']
      },
      tab1Class () {
        return {active: !this.showMap}
      },
      tab2Class () {
        return {active: this.showMap}
      }
    },

    beforeCreate () {
      personsApi.index()
        .then((response) => {
          this.persons = response.data.data
        })
    },

    components: {
      datePicker,
      Multiselect,
      Description,
      MaskedInput,
      Dropzone
    }
  }
</script>

<style scoped>
    .tab-pane h4 {
        background-color: #f7f7f7;
        font-size: 18px;
        text-align: center;
        padding: 7px 10px;
        margin-top: 0;
    }

    .label-primary {
        cursor: pointer;
    }

    #gallery {
        position: relative;
        padding: 0px;
    }

    #gallery li {
        list-style: none;
        position: relative;
        margin-bottom: 10px;
    }

    #gallery button {
        position: absolute;
        bottom: 0px;
        right: 0px;
    }

    video {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/sequences/SequencesForm.vue